<section style="border: 1px solid black; border-radius: 10px; margin: 0 auto ; padding: 3em; text-align: center;">
    <h1 style="color:green;"><span i18n="@@web-inscripciones.conectando-con-tpv">Conectando con TPV</span></h1>
    <p>
        <span i18n="@@web-inscripciones.por-favor-espere">Por favor, espere</span>
        <span i18n="@@web-inscripciones.gracias"> Gracias</span><br />
        <span style="font-size: 10px;" class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
    </p>
    <mat-spinner diameter="40" style="margin: auto;"></mat-spinner>
</section>
<section>
    <!-- $ppRedSys.url = {{$ppRedSys.url}}<br />
    $ppRedSys.datosPagoTPV = {{$ppRedSys.datosPagoTPV}} -->
    
    <!-- <form name="frmTPV" [action]="tpv_url" method="POST" style="display: none !important;">
        <input type="text" name="Ds_SignatureVersion" [ngModel]="datos_pago_TPV.Ds_SignatureVersion" /><br />
        <textarea name="Ds_MerchantParameters" rows="8" cols="40" [ngModel]="datos_pago_TPV.Ds_MerchantParameters"></textarea><br />
        <input type="text" name="Ds_Signature" [ngModel]="datos_pago_TPV.Ds_Signature" /><br/>
    </form> -->
</section>
